import { AppConfig } from '../app.config';

export class SearchQuery {
    // The total number of records
    public total: number;
    // The current page number
    public skip: number;
    public take: number;
    public sortField: string;
    public sortDir: 'asc' | 'desc';

    public searchText = '';
    public filters: any = {};

    public static create(maxItems = 0): SearchQuery {
        const result = new SearchQuery();
        result.skip = 0;
        result.take = maxItems ? maxItems : AppConfig.settings.maxItems;
        return result;
    }

    public set(params: any): void {
        if (params) {
            Object.assign(this, params);
        }
    }
}
